import { render, staticRenderFns } from "./postPortfolioComponent.vue?vue&type=template&id=f536d0e8&scoped=true"
import script from "./postPortfolioComponent.vue?vue&type=script&lang=js"
export * from "./postPortfolioComponent.vue?vue&type=script&lang=js"
import style0 from "./postPortfolioComponent.vue?vue&type=style&index=0&id=f536d0e8&prod&scoped=true&lang=css"
import style1 from "./postPortfolioComponent.vue?vue&type=style&index=1&id=f536d0e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f536d0e8",
  null
  
)

export default component.exports